import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import anime from "animejs";
import { swiperInit } from './swiper';
import { accInit } from './acc';
import { rellaxInit } from './paralax';
import { SMInit } from './scrollmagic';
import { movetoInit } from './moveto';
import { breadlinksInit } from './header';
import { whenScroll } from './watchScroll';
import { simplebarInit } from './scrollbar';

//header・body書き換え
const replaceHead = function (data) {
    const head = document.head;
    const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
    const newPageHead = document.createElement('head');
    newPageHead.innerHTML = newPageRawHead;

    const removeHeadTags = [
        "meta[name='keywords']", "meta[name='description']", "meta[property^='og']", "meta[name^='twitter']", "meta[itemprop]", "link[itemprop]", "link[rel='prev']", "link[rel='next']", "link[rel='canonical']"
    ].join(',');

    const headTags = head.querySelectorAll(removeHeadTags)

    for (let i = 0; i < headTags.length; i++) {
        head.removeChild(headTags[i]);
    }

    const newHeadTags = newPageHead.querySelectorAll(removeHeadTags)

    for (let i = 0; i < newHeadTags.length; i++) {
        head.appendChild(newHeadTags[i]);
    }

    //bodyクラス変更
    let regexp = /\<body.*\sclass=["'](.+?)["'].*\>/gi,
        match = regexp.exec(data.next.html);
    if (!match || !match[1]) {
        // If no body class, remove it
        document.body.setAttribute("class", "");
    } else {
        // Set the new body class
        document.body.setAttribute("class", match[1]);
    }
}

// ページ遷移時に実行する内容

function everyMove() {
    swiperInit()
    SMInit()
    accInit()
    // rellaxInit()
    movetoInit()
    breadlinksInit()
    whenScroll()
    simplebarInit()
}

everyMove()

barba.hooks.before((data) => { })

barba.hooks.enter((data) => {
    document.body.classList.remove("loading")
})

barba.hooks.after((data) => {
    replaceHead(data);
    everyMove()
})

barba.use(barbaPrefetch);

let wrapper = document.querySelector(".wrapper")
let footer_see = false

let duration = 500,
    delay = 500

barba.init({
    transitions: [{
        name: 'page-transition',
        sync: true,
        leave: function (data) {

            // console.log([data.current.container.clientHeight, data.current.container.offsetHeight])

            //フッターがちらっと見えるのを阻止
            let maxheight = Math.round(data.current.container.clientHeight)
            document.querySelector(".Sidebared").style.height = `${maxheight}px`

            footer_see = document.body.classList.contains("footer-see")
            const done = this.async();
            data.current.container.classList.add("js-barba__leave");
            wrapper.classList.add("js-barba__leave");

            let leaveTarget = []

            if (window.innerWidth > 1024) {
                leaveTarget = [data.current.container]
            } else {
                leaveTarget = [wrapper]
            }

            anime.timeline().add({
                targets: leaveTarget,
                opacity: [1, 0],
                top: ["0px", "100px"],
                easing: "cubicBezier(.17,.67,.48,.92)",
                duration: duration,
                complete: () => {
                    data.current.container.classList.remove("js-barba__leave");
                    wrapper.classList.remove("js-barba__leave");
                    done();
                }
            })

            if (window.innerWidth > 1024) {
                //single-worksとフッターが見えている状態でちらっとフッターが見えるのを阻止
                if ((data.current.container.classList.contains("single-works") || data.next.container.classList.contains("single-works") || footer_see)) {
                    anime.timeline().add({
                        targets: [".header .swiper", ".footer"],
                        opacity: [1, 0],
                        easing: "cubicBezier(.17,.67,.48,.92)",
                        duration: duration,
                    })
                }

                //pc時フッターより上でスクロールしたときの遷移時にheaderスライドが上に戻るのを阻止
                // if (!footer_see) {
                //     document.querySelector(".header").style.position = "fixed"
                // }
            }
        },
        enter: function (data) {
            const done = this.async();
            data.next.container.classList.add("js-barba__enter");
            wrapper.classList.add("js-barba__enter");
            let enterTarget = [],
                animeDelay = delay,
                customDelay = 0;

            if (window.innerWidth > 1024) {
                enterTarget = [data.next.container]
            } else {
                enterTarget = [wrapper]
                animeDelay = 0
                customDelay = delay
            }

            setTimeout(() => {
                anime.timeline().add({
                    targets: enterTarget,
                    opacity: [0, 1],
                    top: ["-100px", "0px"],
                    easing: "cubicBezier(.17,.67,.48,.92)",
                    delay: animeDelay,
                    duration: duration,
                    begin: () => {
                        done();
                    },
                    changeBegin: () => {
                        if (data.trigger != "back" && data.trigger != "forward") {
                            window.scrollTo(0, 0)
                        }
                    },
                    complete: () => {
                        enterTarget[0].style.transform = ""
                        document.querySelector(".Sidebared").style.height = ""
                        data.next.container.classList.remove("js-barba__enter");
                        wrapper.classList.remove("js-barba__enter");
                    }
                })
            }, customDelay)

            if (window.innerWidth > 1024) {

                if (!footer_see) {
                    //pc時フッターより上でスクロールしたときの遷移時にheaderスライドが上に戻るのを阻止
                    // setTimeout(() => {
                    //     document.querySelector(".header").style.position = "sticky"
                    // }, delay)
                }
                setTimeout(() => {
                    anime.timeline().add({
                        targets: ".footer",
                        opacity: [0, 1],
                        easing: "cubicBezier(.17,.67,.48,.92)",
                        duration: duration,
                    })

                    //single-worksとフッターが見えている状態でちらっとフッターが見えるのを阻止
                    if ((data.current.container.classList.contains("single-works") || data.next.container.classList.contains("single-works") || footer_see)) {
                        anime.timeline().add({
                            targets: ".header .swiper",
                            opacity: [0, 1],
                            easing: "cubicBezier(.17,.67,.48,.92)",
                            duration: duration,
                        })
                        footer_see = false
                    }
                }, delay)
            }
        }
    }],
})